var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.5,
    cy: 9.5,
    r: 9,
    stroke: "#ECECEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1695 9.50006L13.015 6.65445C13.2002 6.46935 13.2002 6.17008 13.015 5.98498C12.8299 5.79989 12.5306 5.79989 12.3455 5.98498L9.49999 8.8306L6.65453 5.98498C6.46935 5.79989 6.17017 5.79989 5.98508 5.98498C5.7999 6.17008 5.7999 6.46935 5.98508 6.65445L8.83054 9.50006L5.98508 12.3457C5.7999 12.5308 5.7999 12.83 5.98508 13.0151C6.07732 13.1075 6.1986 13.1539 6.3198 13.1539C6.441 13.1539 6.5622 13.1075 6.65453 13.0151L9.49999 10.1695L12.3455 13.0151C12.4379 13.1075 12.5591 13.1539 12.6803 13.1539C12.8015 13.1539 12.9227 13.1075 13.015 13.0151C13.2002 12.83 13.2002 12.5308 13.015 12.3457L10.1695 9.50006Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.3ff203ab.svg";
export { ForwardRef as ReactComponent };